import NavBar from './NavBar';
import EmptyNavBar from './EmptyNavBar';

export { NavBar, EmptyNavBar };
export default NavBar;
